/** Frontmatter for the "week6-waiver-wire-darkness-report" article; the Body lives in week6-waiver-wire-darkness-report.jsx. */
const meta = {
  slug: 'week6-waiver-wire-darkness-report',
  title: 'Week 6 Waiver Wire: The Darkness Report',
  category: 'Waivers',
  author: 'Andy Darkness',
  excerpt:
    'Woody Marks, Germie Bernard and Jameis Winston lead a Week 6 wire shaped by Montgomery, Pittman and a Week 5 report card that says starters beat rentals. A FAAB ladder, the full board, a superflex corner, a D/ST streaming chart built on implied totals, an IDP board, the injury ledger, the Week 5 receipts and the bid sheet.',
  readMinutes: 15,
  date: '2026-10-13',
};

export default meta;
